import styled from 'styled-components';

export const LogoContainer = styled.a`
    display: flex;
    align-items: center;
    justify-content: center;
    height: 50px;
`;

export const TitleContainer = styled.div`
    display: flex;
    flex-direction: column;
    margin-left: 10px;
`;

export const StyledText = styled.p`
    font-size: 32px;
    font-family: Roboto Condensed;
`;

export const WebsiteTitle = styled.p`
    font-family: Roboto Condensed;
    font-weight: bold;
    font-size: 18px;
    letter-spacing: 1px;
    margin: 0;
    color: white;
`;

export const WebsiteSubtitle = styled.p`
    font-family: Helvetica;
    font-weight: 400;
    letter-spacing: 2px;
    text-transform: uppercase;
    font-size: 11px;
    margin: 1px 0 0 0;
    color: #f0f0f0;
`;
